import { reducersActions } from "./new-actions";

import axiosInstance from "../../utils/axiosInterceptor";
import { apicall } from "../../services/api";

const {
    FETCH_BRANDS_REQUEST,
    FETCH_BRANDS_SUCCESS,
    FETCH_BRANDS_FAILURE,
} = reducersActions;


export const fetchBrands = () => async (dispatch) => { 
  dispatch({ type: FETCH_BRANDS_REQUEST });
  try {
    const response = await apicall(`source_business/allBrands`, "get", null, {}, "v3");
    
    dispatch({
      type: FETCH_BRANDS_SUCCESS,
      payload: response.data,
    });
    return response.data; // Return the data for further use if needed
  } catch (error) {
    dispatch({
      type: FETCH_BRANDS_FAILURE,
      payload: error.message,
    });
  }
};
